// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"f1a8ae1f","193":"50cec2c6","499":"45f75347","659":"b1e03d2f","714":"a219de49"}[chunkId] + ".chunk.css";
};